<template>
  <div>
    <vsmallheader></vsmallheader>
    <div>
      <div class="metter">
        <div class="metter-box">
          <div style="font-size:14px;color:#888;display:flex;align-items: center">
            <img
              src="@/assets/resource/adresst.png"
              style="width:15px;height:15px;margin-right:5px"
            />
            当前位置：
          </div>
          <span style="cursor: pointer; font-size: 14px;" @click="retrun">首页</span> /
          <span style="cursor: pointer; font-size: 14px;" @click="retrun">{{form.title}}</span>
        </div>
        <div class="mettera">
          <div class="h2" style="font-size:28">{{form.title}}</div>
          <div class="nav">
            <div class="font-s max-w" :title="form.source">来源: {{form.source}}</div>
            <div class="shu">|</div>
            <div class="font-s">供稿单位：{{form.deptName}}</div>
            <div class="shu">|</div>
            <div class="font-s">浏览量：{{form.readCount}}</div>
            <div class="shu">|</div>
            <div
              class="font-s"
            >发布时间：{{form.publishTime?form.publishTime.substring(0, 10):form.publishTime}}</div>
          </div>
          <div class="aaa"></div>

          <p v-html="htmlcontents" class="ppp"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as news from '@/api/clientshome/index.js';
import vsmallheader from '@/views/smallHeader/index';
import linecom from '@/components/linecom/index';
export default {
  components: {
    vsmallheader,
    linecom,
  },
  data() {
    return {
      dongtai: '',
      id: this.$route.query.id,
      form: '',
      htmlcontents: '',
      pdfUrl: '',
    };
  },
  created() {
    this.pdfUrl =
      '/pdf/web/viewer.html?file=' +
      encodeURIComponent('/uploadfile/test.pdf') +
      '&isdown=false';

    this.getCmsArticleReadCount();

    this.PmiDictionaryGet(this.$route.query.CateId);
  },

  methods: {
    //增加阅读数量
    getCmsArticleReadCount() {
      news.CmsArticleReadCount({ id: this.id }).then((res) => {
        this.getmetter();
      });
    },
    PmiDictionaryGet(cId) {
      let para = {
        id: cId,
      };
      news.PmiDictionaryGet(para).then((res) => {
        this.dongtai = res.result.name;
      });
    },
    getmetter() {
      console.log(this.id);
      news.GetNews({ id: this.id }).then((res) => {
        this.form = res.result;
        console.log(res);
        this.htmlcontents = this.form.contents;
        // this.htmlcontents = this.form.contents.replace(
        //   'border="0"',
        //   'border="1"'
        // );
      });
    },
    retrun() {
      this.$router.go(-1);
    },
    retrunhome() {
      this.$router.push('/home');
    },
  },
  // }
};
</script>

<style scoped>
.metter {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  -webkit-user-select: text;
}
.metter > div:nth-child(1) {
  font-size: 16px;
}

.mettera {
  width: 1200px;
  min-height: 720px;
  margin: 0 auto;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(242, 242, 242, 1);
  border-radius: 5px;
  padding-bottom: 30px;
  -webkit-user-select: text;
}
.h2 {
  line-height: 55px;
  font-size: 28px;
  text-align: center;
  font-weight: 700;
  color: #1a1a1a;
  padding: 0 20px;
  padding-top: 20px;
}
.nav {
  display: flex;
  color: #7f7f7f;
  justify-content: center;
  padding: 10px 20px;
  align-items: center;
}
.shu {
  margin: 0px 10px;
}
.aaa {
  margin-top: 10px;
  height: 1px;
  border-top: 1px solid #dbdbdb;
  margin: 10px 50px 20px 50px;
}
.ppp {
  padding: 0px 100px;
}
/* .ppp >>> p {
  line-height: 30px;
} */
.ppp > p > img {
  width: 900px;
  text-indent: 0em;
}
.metter-box {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
}
.metter-box-img {
  width: 20px;
  height: 20px;
}
.address-margin-r-10 {
  margin-right: 10px;
}
.font-s {
  font-size: 16px;
  white-space: nowrap;
}
.max-w {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Section1 {
  width: 730px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid #f2f2f2;
}
.pdfurlsc {
  width: 1000px;
  margin: 0 auto;
  height: 900px;
}

/* table 样式 */
.ppp >>> table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.ppp >>> table td,
.ppp >>> table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}
.ppp >>> table th {
  background-color: #f1f1f1;
}
.ppp >>> table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
</style>